var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportSelectedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7142 5.099L14.2196 0.684631C14.0991 0.566299 13.937 0.5 13.768 0.5H2.40491C1.07892 0.5 0 1.57875 0 2.90491V20.0951C0 21.4211 1.07875 22.5 2.40491 22.5H16.5022C17.8282 22.5 18.9071 21.4212 18.9071 20.0951V5.5589C18.9071 5.38585 18.8376 5.22018 18.7142 5.099ZM14.4125 2.681L16.6865 4.91437H14.6174C14.5045 4.91437 14.4125 4.82239 14.4125 4.70943V2.681ZM16.5022 21.2109H2.40491C1.78975 21.2109 1.28906 20.7104 1.28906 20.0951V2.90491C1.28906 2.28958 1.78958 1.78906 2.40491 1.78906H13.1236V4.70943C13.1236 5.53322 13.7938 6.20343 14.6176 6.20343H17.618V20.0951C17.618 20.7104 17.1175 21.2109 16.5022 21.2109Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9277 10.7266H4.8418C4.48579 10.7266 4.19727 11.0151 4.19727 11.3711C4.19727 11.7271 4.48579 12.0156 4.8418 12.0156H13.9277C14.2837 12.0156 14.5722 11.7271 14.5722 11.3711C14.5722 11.0151 14.2837 10.7266 13.9277 10.7266Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8418 14.5938H12.2502C12.6062 14.5938 12.8947 14.3052 12.8947 13.9492C12.8947 13.5932 12.6062 13.3047 12.2502 13.3047H4.8418C4.48579 13.3047 4.19727 13.5932 4.19727 13.9492C4.19727 14.3052 4.48579 14.5938 4.8418 14.5938Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.144 15.8828H4.8418C4.48579 15.8828 4.19727 16.1713 4.19727 16.5273C4.19727 16.8833 4.48579 17.1719 4.8418 17.1719H13.144C13.4998 17.1719 13.7885 16.8833 13.7885 16.5273C13.7885 16.1713 13.4998 15.8828 13.144 15.8828Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportSelectedIcon);
export default __webpack_public_path__ + "static/media/reportSelectedIcon.de53086070402a3c15880a87be34d772.svg";
export { ForwardRef as ReactComponent };